<template>
    <div v-if="chatImageURL && titleImageUrl">
        <Launcher
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :open="openChat"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            :title="chatBotTitle"
            :placeholder="chatBotPlaceholder"
            :chatImageUrl="chatImageURL"
        />
    </div>
</template>
<script>
import config from "../config";
import services from "../services/HttpService";
import Launcher from "./chatbot/Launcher";
export default {
    components: {
        Launcher
    },
    data: () => ({
        participants: [
            {
                id: 'support',
                name: 'Max Help'
            }
        ],
        titleImageUrl: '/static/chatbot-user.png',
        chatImageURL:'/static/chatbot-user.png',
        messageList: [
            { type: config.apiAiDefaultType, author: config.apiAiDefaultAuthor, data: { text: config.chatBotDefaultMsg } }
        ],
        newMessagesCount: 0,
        isChatOpen: false,
        showTypingIndicator: '',
        colors: {
            header: {
                bg: '#ff812b',
                text: '#ffffff'
            },
            launcher: {
                bg: '#4e8cff'
            },
            messageList: {
                bg: '#ffffff'
            },
            sentMessage: {
                bg: '#ffffff',
                text: '#5b5b5b'
            },
            receivedMessage: {
                bg: '#ff812b',
                text: '#ffffff'
            },
            userInput: {
                bg: '#ff812b',
                text: '#7a7a7a'
            }
        },
        alwaysScrollToBottom: false,
        messageStyling: true,
        chatBotTitle:config.chatBotTitle,
        chatBotPlaceholder:config.chatBotPlaceholder
    }),
    async created (){
        const self =  this;
        await self.getChatIconImage();
    },
    methods: {
        async onMessageWasSent (reqData){
            const self = this;
            try {
                self.newMessagesCount = self.isChatOpen ? this.newMessagesCount : self.newMessagesCount + 1;
                self.messageList.push(reqData);
                services.post("get-intent", {"text":reqData.data.text})
                .then(res => {
                    self.newMessagesCount = self.isChatOpen ? this.newMessagesCount : self.newMessagesCount + 1;
                    if (res.data.intentData && res.data.intentData.length > 0) {
                        self.messageList.push({ author: config.apiAiDefaultAuthor, type: config.apiAiDefaultType, data: { text:res.data.intentData }});
                    }else{
                        self.messageList.push({ author: config.apiAiDefaultAuthor, type: config.apiAiDefaultType, data: { text:config.apiAiNotUnderstandMsg }});
                    }
                })
                .catch(err => {
                    console.log(JSON.stringify(err));
                });
            } catch (e) {
                console.log(e);
            }
        },
        openChat () {
            this.isChatOpen = true
            this.newMessagesCount = 0
        },
        closeChat () {
            this.isChatOpen = false
        },
        getChatIconImage(){
            const self = this,wApp = window.getApp;
            let currentDate = new Date();
            let currentDay = currentDate.getDay();
            wApp.$emit("showLoader", {
                show: true
            });
            services.get("chatbot-avatars/public-url?week_day_number="+currentDay)
            .then(function (result) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.titleImageUrl = result.data.data.avatar_url;
                self.chatImageURL = result.data.data.avatar_url;
            })
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
            });
        }
    }
}
</script>
<style>
.sc-chat-window.opened{
  z-index:999;
  background: #f2f2f2!important;
}
.sc-header{
    border-color: #ff812b !important;
    border-radius: 0px!important;
}
.sc-user-input--buttons{
    right:0px !important;
  
}
.sc-user-input--send-icon{
    margin-top: 5px !important;
}
.sc-user-input--send-icon-wrapper{
    background: #ff812b !important;
    border-radius: 5px;
    display: block;
    padding: 5px!important;
    height: 40px;
    width: 40px;
}
.sc-message--text{
    white-space: normal !important;
}
.sc-message--text p{
    margin-bottom: 0px !important;
}
.sc-header--title {
   font-size: 24px;
    font-weight: 900;
    text-indent: 90px;
    position: relative;
    font-family: 'Roboto', sans-serif!important;
}
.user-list td{
    color:#444444;
}
.sc-launcher {
    right: 21px!important;
    bottom: 68px!important;
    z-index: 9!important;
    padding: 3px!important;
    height: 109px!important;
    background-size: 100%;
    position: absolute !important;
}
.sc-launcher.opened:before{
    box-shadow:none !important;
}
.sc-launcher .sc-open-icon, .sc-launcher .sc-closed-icon{
    width: 60px;
    height: 60px;
    position: fixed;
    right: 20px!important;
    bottom: 67px!important;
}
.sc-header{
    min-height: 50px!important;
    padding: 0px!important;
}
.sc-header--img {
    max-width: 84px!important;
    max-height: 84px;
    position: absolute;
    top: -40px;
    left: 10px;
    border:#ffffff solid 4px;
    padding: 0px!important;
    z-index: 3;
    -webkit-box-shadow: -1px 0px 23px 0px rgba(196,188,196,1);
-moz-box-shadow: -1px 0px 23px 0px rgba(196,188,196,1);
box-shadow: -1px 0px 23px 0px rgba(196,188,196,1);
}
.sc-chat-window {
    height: calc(100% - 204px)!important;
    width: 315px!important;
    right: 16px!important;
   -moz-box-shadow: 0 0 5px 5px #888;
-webkit-box-shadow: 0 0 5px 5px#888;
box-shadow: 0 0 5px 5px #888;
    
}
.sc-user-input
{
   border-radius: 0px!important; 
       min-height: 65px!important;  
}
.sc-message--avatar{ display: none;}
.sc-message--text {
    padding: 7px 20px!important;   
    border-radius: 21px!important;   
}
.sc-message--content.sent .sc-message--text
{
    border:#7a7a7a solid 1px;

}
.sc-user-input--text {
    border: #fff solid 1px!important; 
    margin: 9px!important; 
    border-radius: 5px!important; 
    padding:5px!important; 
    max-width: 248px!important; 
    background: #ffffff!important; 
    height: 30px!important;;
    margin: 15px 10px!important;
    line-height: 15px!important;
}
.sc-message { width: 268px!important; }
.sc-message-list {border: #7a7a7a solid 1px;}
.sc-user-input--buttons {   width: 100px!important; }
.sc-user-input--send-icon-wrapper {font-size: 21px;}
.sc-launcher.opened{display:none}
.sc-header--close-button{
    width: 50px !important;
    height: 50px !important;
    margin-right: 0px !important;
    border-radius: 0px !important;
    background: #ff812b !important;
}
.sc-chat-window{
    bottom:55px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/ChatBot.vue